<template>
  <InfiniteScrollRelatedCellList
    v-if="cellList && cellList.length"
    :key="`infinite-scroll_related_${$route.fullPath}`"
    :content-info="contentInfo"
    :cell-list="cellList"
    :thumbnail-info="thumbnailInfo"
    @load-more="loadMore"
  />
</template>

<script>
import { filter as _filter, get } from 'lodash'
import { mapMutations } from 'vuex'
import InfiniteScrollRelatedCellList from '@/components/section/template/cell/InfiniteScrollRelatedCellList'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { MovieInfoService, VodInfoService } from '@/common/api/api.service'

export default {
  name: 'RelatedContentList',
  components: {
    InfiniteScrollRelatedCellList
  },
  props: {
    section: {
      type: String,
      default: ''
    },
    contentInfo: {
      type: Object,
      default: () => {}
    },
    landingInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isEmptyList: true,
      thumbnailInfo: {},
      endOfList: false,
      offset: 0,
      limit: 20,
      cellList: []
    }
  },
  computed: {
    isMovieSection () {
      return this.section === 'movie'
    }
  },
  methods: {
    ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
    async setData () {
      this.showLoadingProgress()

      const { program_id: programID = '' } = this.landingInfo
      const { movieid: movieID = '' } = this.contentInfo
      const tabRelated = _filter(get(this.landingInfo, 'landing_list.tab', []), { type: 'related' })
      let path = ''
      if (tabRelated && tabRelated.length > 0) {
        path = get(tabRelated[0], 'path')
      }
      try {
        const { data } = this.isMovieSection
          ? await MovieInfoService.getMovieRelatedContents({ movieid: movieID, offset: this.offset, limit: this.limit })
          : await VodInfoService.getVodRelatedContents({ programid: programID, offset: this.offset, limit: this.limit, path: path })

        this.hideLoadingProgress()

        if (this.offset === 0) {
          this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
        }

        let resultList = get(data, 'cell_toplist.celllist', [])
        this.endOfList = resultList.length === 0
        // this.endOfList = resultList.length < this.limit
        this.isEmptyList = resultList.length === 0
        if (this.endOfList || this.isEmptyList) {
          return
        }
        this.offset += this.limit
        this.cellList = this.cellList.concat(resultList)
      } catch (e) {
        this.hideLoadingProgress()
        this.$toast({ message: '관련 영상 정보를 가져오지 못했습니다.' })
        console.error(e)
      }
    },
    loadMore () {
      if (this.isMovieSection) return
      if (this.endOfList) return
      this.setData()
    },
    reload () {
      this.offset = 0
      this.cellList = []
      location.reload()
    }
  },
  created () {
    this.setData()
  }
}
</script>
